<template>
  <div class="content">
    <div class="header">
      <img class="back" :src="require('../../assets/imgs/ssh.png')" />
      <img class="logo" v-lazy="require('../../assets/imgs/logo.png')" :style="abortLogo" />
      <el-tooltip v-show="whichcomp != 'abort'" placement="bottom" effect="light">
        <div slot="content">
          <div>
            <img v-lazy="require('../../assets/imgs/code1.png')" />
            <img v-lazy="require('../../assets/imgs/code2.png')" />
          </div>
          <el-row :gutter="20" class="header_code">
            <el-col :span="12">
              <p>微信号</p>
            </el-col>
            <el-col :span="12">
              <p>公众号</p>
            </el-col>
          </el-row>
        </div>
        <div class="phone">联系电话：18510005207（微信同号）</div>
      </el-tooltip>
      <img class="gsjj" v-if="whichcomp == 'abort'" v-lazy="require('../../assets/imgs/gsjj.png')">
      <div class="headermenu" :style="abortMenu">
        <ul>
          <li>
            <a @click="choosencomp(1, $event)" :class="whichcomp == 'ldt' ? 'active' : ''">AI朗读亭</a>
          </li>
          <li>
            <a @click="choosencomp(5, $event)" :class="whichcomp == 'szr' ? 'active' : ''">AI数字人</a>
          </li>
          <li>
            <a @click="choosencomp(2, $event)" :class="whichcomp == 'msp' ? 'active' : ''">电子书墨水屏</a>
          </li>
          <li>
            <a @click="choosencomp(3, $event)" :class="whichcomp == 'room' ? 'active' : ''">智慧阅览室</a>
          </li>
          <li>
            <a @click="choosencomp(4, $event)" :class="whichcomp == 'abort' ? 'active' : ''">公司简介</a>
          </li>
        </ul>
      </div>
      <img v-lazy="require('../../assets/imgs/play.png')" class="playicon" @click="videoPlay" v-if="['msp'].includes(whichcomp)" />
      <div v-if="['ldt', 'szr'].includes(whichcomp)" class="hd-img" :class="whichcomp"></div>
      <video loop="loop" preload="auto" v-if="whichcomp=='msp'" @click="videoPlay" :src="'http://117.21.14.240:8888/company/msp.mp4'" class="hedaervideo"></video>
    </div>
    <component :is="whichcomp"></component>
    <div class="footer">
      <div class="footer_content">
        <el-row>
          <el-col :span="4">&nbsp;</el-col>
          <el-col :span="8" class="footer_detail">
            <p>
              <span class="footer_title">电话：</span>
              <span class="footer_data">18510005207 （微信同号）</span>
            </p>
            <p>
              <span class="footer_title">邮箱：</span>
              <span class="footer_data">2235088075@qq.com</span>
            </p>
            <p>
              <span class="footer_title">网址： </span>
              <span class="footer_data">www.zbxingzhi.cn</span>
            </p>
            <p>
              <span class="footer_title">地址： </span>
              <span class="footer_data">广州市黄埔区科学城科学大道162号创意大厦B3栋1002房</span>
            </p>
            <p>
              <span class="footer_title">备案号： </span>
              <a class="footer_data" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2023007437号</a>
            </p>
            <img class="brid" v-lazy="require('../../assets/imgs/bird.png')" />
          </el-col>
          <el-col :span="8" class="footer_detail">
            <div class="footer_code">
              <el-row>
                <el-col :span="12">
                  <img v-lazy="require('../../assets/imgs/code1.png')" />
                  <p>微信二维码</p>
                </el-col>
                <el-col :span="12">
                  <img v-lazy="require('../../assets/imgs/code2.png')" />
                  <p>微信公众号</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="4">&nbsp;</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import abort from "./abort";
import ldt from "./ldt";
import msp from "./msp";
import room from './room'
import szr from './szr'

export default {
  name: "pcIndex",
  components: {
    abort,
    ldt,
    msp,
    room,
    szr
  },
  data () {
    return {
      whichcomp: "ldt",
      abortLogo: { "top": "-490px", "left": "-25vw" },
      abortMenu: { "top": "-590px" },
      components: ["ldt", "msp", "room", "abort", "szr"]
    };
  },
  created () {
    if (window.location.href.split('?').length > 1) {
      var cs = window.location.href.split('?')[1].split('&');
      if (cs.length > 0) {
        this.whichcomp = cs[0];
      }
    }
  },
  methods: {
    videoPlay () {
      var video = document.querySelector(".hedaervideo");
      var playicon = document.querySelector(".playicon");
      if (video.paused) {
        playicon.style.display = "none"
        video.play()
      } else {
        playicon.style.display = "inline-block"
        video.pause();
      }
    },
    choosencomp (x, e) {
      e = e.currentTarget;
      document.querySelectorAll(".headermenu a").forEach(item => {
        if (item == e) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
      var which = this.components[x - 1];
      console.log(which)
      if (which == "abort") {
        this.abortLogo.top = "-544px";
        this.abortLogo.left = "-16.25vw";
        this.abortMenu.top = "-597px";
      } else {
        if (which != 'room') {
          var video = document.querySelector(".hedaervideo");
          if (video && !video.paused) {
            document.querySelector(".hedaervideo").pause();
          }
          let playIcon = document.querySelector(".playicon")
          if (playIcon) playIcon.style.display = "inline-block";

        }
        this.abortLogo.top = "-490px";
        this.abortLogo.left = "-25vw";
        this.abortMenu.top = "-590px";
      }
      this.whichcomp = which
    }
  },
};
</script>
<style scoped>
.header {
  position: relative;
  height: 500px;
  width: 100%;
}
.back {
  width: 100%;
  height: 500px;
  object-fit: unset;
}
.logo {
  position: relative;
  top: -490px;
  left: -25vw;
}
.ldt {
  position: relative;
  top: -300px;
  left: -19.5vw;
}
.playicon {
  position: absolute;
  top: 25vh;
  z-index: 999;
  right: 23vw;
}
.hd-img{
  position: absolute;
  top: auto;
  bottom: 0;
  left: auto;
  right: 12vw;
  width: 605px;
  height: 414px;
  background: no-repeat center/contain;
}
.hd-img.ldt{
  background-image: url("../../assets/imgs/20250903/ldt/pc_index_xnr.png");
}
.hd-img.szr{
  background-image: url("../../assets/imgs/20250903/szr/pc_index_xnr.png");
}
.hedaervideo {
  position: relative;
  top: -530px;
  right: -25vw;
  display: inline-block;
  width: 28vw;
  object-fit: cover;
  border: none;
  border-radius: 10px;
  height: 35vh;
}
.header_code p {
  text-align: center;
}
.phone {
  position: relative;
  top: -23.5vh;
  width: 24.8vw;
  left: 22.3vw;
  height: 5vh;
  line-height: 5vh;
  color: white;
  font-size: 25px;
  background-color: #484848;
  text-align: center;
}
.gsjj {
  position: relative;
  top: -25vh;
  left: -5vw;
}
.headermenu {
  position: relative;
  top: -590px;
  left: 24vw;
}
.headermenu li {
  list-style-type: none;
  display: inline-block;
  margin-right: 5vw;
  font-size: 22px;
  font-weight: bolder;
}
.headermenu li a {
  color: #999999;
  text-decoration: none;
}
.headermenu li .active {
  color: black;
}
.footer {
  margin-top: 20vh;
  height: 300px;
}
.footer_content {
  background-image: url("../../assets/imgs/footer_back.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.footer_detail {
  margin-top: 2vh;
}
.footer_content p {
  margin-top: 3vh;
  font-size: 24px;
  text-align: left;
}
.footer_title {
  color: #999999;
}
.footer_data {
  font-weight: bolder;
  color: #231815;
}
.brid {
  position: relative;
  top: -240px;
  left: 7vw;
}
.footer_code {
  margin-top: 5vh;
}
.footer_code p {
  text-align: center;
  margin-top: 1vh;
}
.content {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/index.vue